import {Component, Input, OnInit} from '@angular/core';
import {IntegrationModel, QRCodeContentTypes} from '../../../models/qrcode-integrations/integration.model';
import {DeepLinkTypesModel} from '../../../landing-page/deep-linking/DeepLinkTypes.model';

@Component({
  selector: 'app-evo-integration-qrcode',
  templateUrl: './evo-integration-qrcode.component.html',
  styleUrls: ['./evo-integration-qrcode.component.css']
})
export class EvoIntegrationQrcodeComponent implements OnInit {

  @Input() integration: IntegrationModel;
  @Input() size = 200;

  constructor() { }

  ngOnInit() {
  }

  getQRData(): string {
    return EvoIntegrationQrcodeComponent.qrDataFor(this.integration);
  }

  /**
   * The text encoded in the QR code of an integration. Also what gets copied as the link.
   */
  static qrDataFor(integration: IntegrationModel): string {

    const deepLinkType = DeepLinkTypesModel.integration;

    if (integration.contentType === QRCodeContentTypes.url) {

      // TODO: Add logic for url based logic
      const integrationId = integration._id;
      const integrationType = integration.integrationType;

      return `https://www.evolytes.com/appLink?type=${deepLinkType}&integrationId=${integrationId}&integrationType=${integrationType}`;

    } else if (integration.contentType === QRCodeContentTypes.json) {

      const jsonBody = {
        type: deepLinkType,
        integrationId: integration._id,
        integrationType: integration.integrationType
      };

      return JSON.stringify(jsonBody);

    }

    return null;

  }

}
